export enum NodeTypes {
  anchor = 'readme-anchor',
  callout = 'rdme-callout',
  codeTabs = 'code-tabs',
  embedBlock = 'embed-block',
  emoji = 'gemoji',
  figcaption = 'figcaption',
  figure = 'figure',
  glossary = 'readme-glossary-item',
  htmlBlock = 'html-block',
  i = 'i',
  imageBlock = 'image-block',
  plain = 'plain',
  recipe = 'recipe',
  reusableContent = 'reusable-content',
  tableau = 'tableau',
  /** @deprecated Deprecated in favor of `recipe`. */
  tutorialTile = 'tutorial-tile',
  variable = 'readme-variable',
}
